import { render } from "./Transition.vue?vue&type=template&id=853a7044"
import script from "./Transition.vue?vue&type=script&lang=js"
export * from "./Transition.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__